<script setup lang="ts">
import type { Schema } from '@tix/openapi-sdk'

type TicketGroup = Schema<'ticket_group'>

type Props = {
  name: TicketGroup['name']
  summary?: TicketGroup['summary']
  description?: TicketGroup['description']
}

defineProps<Props>()
</script>

<template>
  <div class="donation-header">
    <h2 class="donation-header-title">{{ name }}</h2>

    <p v-if="summary" class="donation-header-summary">{{ summary }}</p>

    <div v-if="description" v-shtml="description" class="donation-header-description" />
  </div>
</template>

<style scoped>
.donation-header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1-5);
  color: var(--text-primary);
  word-break: break-word;

  .donation-header-title {
    font-size: var(--size-xl);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-heading);
    margin: 0;
  }

  .donation-header-summary {
    font-size: var(--size-md);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-heading);
    margin: 0;
  }

  .donation-header-description {
    font-size: var(--size-sm);
    line-height: var(--line-height-body);
  }
}
</style>
